import { useMutation } from 'react-query';

import { apiClient } from 'src/services/api/client';

const PATH = 'api/landlord/onboard/complete';

export const useCompleteOnboarding = () => {
    return useMutation(
        () => apiClient(PATH, { method: 'patch' })
    );
};
